import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { RestService } from "../../master-services/Rest/rest.service";
import swal from "sweetalert2";
import { Router } from "@angular/router";
import { UploadService } from "../../master-services/services/upload.service";
import { UUID } from "angular2-uuid";
import { ActivatedRoute, Params } from "@angular/router";
import { getElement } from "@syncfusion/ej2-base";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import { ICustomerType } from "../../master-models/customer-type.model";
import { ICustomerContact } from "../../master-models/customer-contact.model";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";
import { error } from "console";

interface regionalAdvisor {
  userId?: number;
  customerAdvisorId?: number;
}

interface regionalSelectInterface {
  id?: number;
  code?: string;
  description?: string;
  cheked?: boolean;
  advisors?: regionalAdvisor[];
}

@Component({
  selector: "app-master-update-customer",
  templateUrl: "./master-update-customer.component.html",
  styleUrls: [
    "./master-update-customer.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterUpdateCustomerComponent implements OnInit {
  ///Construidos JMV
  selectedBusinessId:any=0;
  selectedcityId:any=0;
  selecteDepartmentId:any=0;
  selectedBusinessIdForm: any = 0;
  addressForm: string = "";
  addressObservation: string = "";
  deliveryAddress: any;
  isModalVisible = false;
  isVisibleEdit = false;
  editaddress: any;
  editObservation: any;
  editRegionalDescription: any;
  editRegionalId: any;
  idEditAddres: any;

  ///Construidos JMV

  selectedFiles: FileList;
  dataMasters: any;
  dataOffices: any;
  typeDocuments: any;
  priceList: any;
  departments: any;
  department: any;
  citi: any;
  cities: any;
  citiesOffice: any;
  citiesOfficeUpdate: any;
  paymentConditions: any;
  elementDelete: any;

  currentOffice: any;
  currentCustomerId: any = 0;

  myForm: FormGroup;
  myFormUpdate: FormGroup;

  myFormCreateOffice: FormGroup;
  myFormUpdateOffice: FormGroup;

  opcionSeleccionado: any = 0;
  check = false;
  enable = false;

  submitted = false;
  submittedUpdated = false;

  submittedOffice = false;
  submittedOfficeUpdated = false;

  enabledCreated = true;
  enabledCreatedOffice = true;
  enabledCreatedOfficeUpdate: boolean;
  public imagePath;
  imgURL: any;
  public message: string;
  enabledUpdated = true;
  idCustomerCreated;

  showButtonUpdated = 0;
  selectedValue = 0;
  switchCreate = true;
  switchUpdate = true;

  selectedTypeDocumentId: any = 0;
  selectedPriceListId: any = 0;
  selectedPaymentConditionId: any = 0;
  selectedDepartmentId: any = 0;
  selectedCityId: any = 0;

  selectedDepartmentOfficeId: any = 0;
  selectedCityOfficeId: any = 0;

  selectedDepartmentOfficeIdUpdate: any = 0;
  selectedCityOfficeIdUpdate: any = 0;

  selectedTypeDocumentIdUpdate: any = 0;
  selectedPriceListIdUpdate: any = 0;
  selectedPaymentConditionIdUpdate: any = 0;
  selectedDepartmentIdUpdate: any = 0;
  selectedCityIdUpdate: any = 0;
  customer: any;

  checkAllRegional = false;
  regional = [];
  regionals: Array<regionalSelectInterface> = [];
  customerTypes: ICustomerType[] = [];
  customerOrigins = [];
  itemRegional: regionalSelectInterface;
  rowsRegionals: any;
  rowsRegional: any;
  selectRegional: Array<regionalSelectInterface> = [];
  valor: any;
  regionalCustomer = [];
  documentType: any = 0;

  userId: number = 0;
  profileType: number = 0;
  originalCustomerStatus: any = null;

  newOrigin: string = '';
  originIdToEdit: number = 0;

  // Customer Contacts
  customerContacts: ICustomerContact[] = [];
  contactForm: any = { name: '', email: '', telephone: '', regional_id: 0 };
  editContactId: number = 0;
  isContactModalVisible: boolean = false;
  isEditingContact: boolean = false;

  userAdvisors: { id: number, name: string }[] = [];
  customerAdvisors: { id: number, user_id: number, regional_id: number, customer_id: number }[] = [];

  @ViewChild('modalFormOrigin') modalFormOrigin: ModalBasicComponent;

  constructor(
    private restService: RestService,
    private router: Router,
    private uploadService: UploadService,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService
  ) {
    this.userId = Number(localStorage.getItem("userid"));
    this.profileType = Number(localStorage.getItem("profile"));
    
    this.getMasters(0);
    // this.getOffices();
    this.currentCustomerId = this.rutaActiva.snapshot.params.id;
    this.getAllCustomerAdvisors();
    this.getRegionals();
    this.getAllUserAdvisors();
    this.getOffices(this.currentCustomerId);
    //    this.getRegionalId(this.currentCustomerId);
    console.log(this.currentCustomerId);

    const businessName = new FormControl("", Validators.required);
    const typeDocumentId = new FormControl("", Validators.required);
    const documentId = new FormControl("", [
      Validators.required,
      Validators.pattern("^[0-9]+$")
    ]);
    const telephone = new FormControl("", [
      Validators.pattern("^[0-9]+$")
    ]);
    const address = new FormControl("", Validators.required);
    const priceMargin = new FormControl("", Validators.required);
    // const priceListId = new FormControl('', Validators.required);

    const paymentConditionId = new FormControl("", Validators.required);
    const departmentId = new FormControl("", Validators.required);
    const cityId = new FormControl("", Validators.required);
    const customerType = new FormControl(0, Validators.required);
    const customerOrigin = new FormControl(0, Validators.required);
    const comercialEmail = new FormControl('', [
      Validators.email,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]);

    const businessNameUpdate = new FormControl("", Validators.required);
    const typeDocumentIdUpdate = new FormControl("", Validators.required);
    const documentIdUpdate = new FormControl("", [
      Validators.required,
      Validators.pattern("^[0-9]+$")
    ]);
    const telephoneUpdate = new FormControl("", [
      Validators.pattern("^[0-9]+$")
    ]);
    const emailUpdate = new FormControl("", [
      Validators.required,
      Validators.email,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]);
    const addressUpdate = new FormControl("", Validators.required);
    const priceMarginUpdate = new FormControl("", Validators.required);
    //  const priceListIdUpdate  = new FormControl('', Validators.required);
    const paymentConditionIdUpdate = new FormControl("", Validators.required);
    const departmentIdUpdate = new FormControl("", Validators.required);
    const cityIdUpdate = new FormControl("", Validators.required);

    const nameOffice = new FormControl("", Validators.required);
    const telephoneOffice = new FormControl("");
    const departmentOffice = new FormControl("", Validators.required);
    const citytOffice = new FormControl("", Validators.required);
    const addressOffice = new FormControl("", Validators.required);

    const nameOfficeUpdate = new FormControl("", Validators.required);
    const telephoneOfficeUpdate = new FormControl("");
    const departmentOfficeUpdate = new FormControl("", Validators.required);
    const citytOfficeUpdate = new FormControl("", Validators.required);
    const addressOfficeUpdate = new FormControl("", Validators.required);

    this.myFormCreateOffice = new FormGroup({
      nameOffice: nameOffice,
      telephoneOffice: telephoneOffice,
      departmentOffice: departmentOffice,
      citytOffice: citytOffice,
      addressOffice: addressOffice,
    });

    this.myFormUpdateOffice = new FormGroup({
      nameOfficeUpdate: nameOfficeUpdate,
      telephoneOfficeUpdate: telephoneOfficeUpdate,
      departmentOfficeUpdate: departmentOfficeUpdate,
      citytOfficeUpdate: citytOfficeUpdate,
      addressOfficeUpdate: addressOfficeUpdate,
    });

    this.myForm = new FormGroup({
      businessName: businessName,
      typeDocumentId: typeDocumentId,
      documentId: documentId,
      telephone: telephone,
      address: address,
      priceMargin: priceMargin,
      paymentConditionId: paymentConditionId,
      departmentId: departmentId,
      cityId: cityId,
    });

    this.myFormUpdate = new FormGroup({
      businessNameUpdate: businessNameUpdate,
      typeDocumentIdUpdate: typeDocumentIdUpdate,
      documentIdUpdate: documentIdUpdate,
      telephoneUpdate: telephoneUpdate,
      emailUpdate: emailUpdate,
      addressUpdate: addressUpdate,
      priceMarginUpdate: priceMarginUpdate,
      paymentConditionIdUpdate: paymentConditionIdUpdate,
      departmentIdUpdate: departmentIdUpdate,
      cityIdUpdate: cityIdUpdate,
      customerType: customerType,
      comercialEmail: comercialEmail,
      customerOrigin: customerOrigin
    });
  }

  getRegionals() {
    this.restService
      .getRegional()
      .then((data) => {
        const resp: any = data;
        console.log(resp);
        console.log("OEOEOEOEOEEO");
        console.log("---------------------------");
        this.rowsRegional = resp.data;

        console.log("información de regional");
        console.log(this.rowsRegional);
        console.log(this.rowsRegional.length);
        this.getRegionalId(this.currentCustomerId);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  ccNit() {
    // documentType

    const data = this.selectedTypeDocumentId.id;

    if (data == 1) {
      this.documentType = 0;
      console.log(data);
    } else {
      this.documentType = 1;
      console.log(data);
    }
  }

  validateFormat(event: KeyboardEvent) {
    const key = String.fromCharCode(event.keyCode);
    const regex = /^[0-9]$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent) {
    let pasteData = '';
    if (event.clipboardData) {
      pasteData = event.clipboardData.getData('text');
    }
    const regex = /^[0-9]+$/;
    if (!regex.test(pasteData)) {
      event.preventDefault();
    }
  }

  getRegionalId(id: number) {
    this.restService.getRegionalId(id).then((data) => {
      const resp: any = data;
      console.log("Acaaaa respuesta de regional id", resp);
      console.log("OEOEOEOEOEEO");
      console.log(resp.data_customerRegionals);
      console.log("----------------data_customerRegionals-----------");
      this.rowsRegionals = resp.data_customerRegionals;
      this.regional = [];

      console.log(this.rowsRegionals);
      console.log(this.rowsRegional);
      this.rowsRegional.forEach((item) => {
        console.log(item);
        this.itemRegional = {
          id: item.id,
          code: item.code,
          description: item.description,
          cheked: false,
          advisors: []
        };
        this.regionals.push(this.itemRegional);
      });
      // rowsRegionals  Son las regionales del customer
      // rowsRegional  Son las regionales del creadas

      this.rowsRegionals.forEach((value) => {
        console.log(value.regional_id);
        let index = this.regionals.indexOf(
          this.regionals.find((x) => x.id == value.regional_id)
        );
        console.log(index);
        if (index != -1) {
          const advisors = Array.isArray(this.customerAdvisors) ? this.customerAdvisors : [];
          const foundAdvisors = advisors.filter(
            ca => ca.regional_id === this.regionals[index].id
          );

          this.itemRegional = {
            id: this.regionals[index].id,
            code: this.regionals[index].code,
            description: this.regionals[index].description,
            cheked: true,
            advisors: foundAdvisors.map(ca => ({ userId: ca.user_id, customerAdvisorId: ca.id }))
          };

          this.regionals.splice(index, 1);
          this.regionals.push(this.itemRegional);
        }
        console.log(this.regionals);
      });
      console.log(this.regional);
    });
  }

  

  getCities() {
    console.log("Acaa departamento cuando cambia",this.selectedDepartmentId)
    // console.log(this.opcionSeleccionado);
    this.selectedCityId = 0;

     this.restService.getCities(Number(this.selectedDepartmentId)).then(data => {
       const resp: any = data;
       console.log(data);
       swal.close();
       this.cities = resp.data;
       console.log(this.cities);
     }).catch(error => {
       console.log(error);
     });
  }

  checkUncheckAllPart(event: any) {
    this.checkAllRegional = event.target.checked;
    for (let i = 0; i < this.regionals.length; i++) {
      console.log("lo encontre" + i);
      this.regionals[i].cheked = event.target.checked;
    }
  }

  partChangeActive(event: any, item: any) {
    console.log("valor para editar");
    console.log(event);
    console.log(item);
    console.log(item.id);

    for (let i = 0; i < this.regionals.length; i++) {
      if (this.regionals[i].id == item.id) {
        console.log(item);
        console.log("lo encontre" + i);
        this.regionals[i].cheked = event.target.checked;
        console.log(this.regionals[i]);
      }
    }
  }

  finalRegional() {
    this.selectRegional = [];
    for (let i = 0; i < this.regionals.length; i++) {
      console.log("lo encontre" + i);
      if (this.regionals[i].cheked) {
        console.log(this.regionals[i].cheked);
        this.selectRegional.push(this.regionals[i]);
      }
    }
    let regionalSelec = "";
    regionalSelec = this.currentCustomerId;
    console.log(regionalSelec);
    console.log(this.currentCustomerId);

    for (let i = 0; i < this.selectRegional.length; i++) {
      regionalSelec = regionalSelec + "@" + this.selectRegional[i].id;
    }
    console.log(this.selectRegional);
    console.log(regionalSelec);

    if (regionalSelec != "") {
      swal({
        title: "Validando información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();

      this.restService
        .customerRegionalSelect(regionalSelec)
        .then((data) => {
          const resp: any = data;
          console.log("envio");
          console.log(resp);
          if (resp.success === false) {
            swal({
              title: "Falla en la actualizacion",
              text: "Este cliente no se pudo actualizar",
              type: "error",
            });
          } else {
            swal({
              title: "Sucursales guardadas",
              type: "success",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          swal.close();
        });
    } else {
      swal({
        title: "Se presentó un problema",
        text: "Favor selecionar al menos una opcion.",
        type: "error",
      });
    }
  }

  ngOnInit() {
    console.warn("Acaaa iniciando el componente");
    this.getAllCustomerOrigins();
    this.getDeliverysAdrres();
    this.getAllCustomerTypes();
    this.getCustomerContacts();
  }

  ngAfterContentInit() {
  }

  updateBrand(brand) {
    console.log(brand);
    this.currentOffice = brand;
    console.log(this.currentOffice);
    if (this.currentOffice.status === "0") {
      this.enabledUpdated = true;
    } else {
      this.enabledUpdated = false;
    }

    this.myFormUpdateOffice
      .get("nameOfficeUpdate")
      .setValue(this.currentOffice.branch_name);
    this.myFormUpdateOffice
      .get("telephoneOfficeUpdate")
      .setValue(this.currentOffice.telephone);

    this.myFormUpdateOffice
      .get("addressOfficeUpdate")
      .setValue(this.currentOffice.address);

    this.selectedDepartmentOfficeIdUpdate = this.currentOffice.department_id;

    if (this.currentOffice.status == 0) {
      this.enabledCreatedOfficeUpdate = true;
    } else {
      this.enabledCreatedOfficeUpdate = false;
    }

    this.getCitiesOfficeUpdate();
    this.selectedCityOfficeIdUpdate = this.currentOffice.city_id;

    document.getElementById("uploadBrand").click();
  }

  upload() {
    const file = this.selectedFiles.item(0);
    const uuid = UUID.UUID();
    console.log(uuid);
    console.log(file.name + "" + file.type);
    const extension = file.name
      .substring(file.name.lastIndexOf("."))
      .toLowerCase();
    console.log(extension);
    this.uploadService.uploadFile(file);
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    console.log(this.selectedFiles);
  }

  ChangingValue() {
    this.selectedTypeDocumentIdUpdate = this.selectedTypeDocumentId.id;
    //  this.selectedPriceListIdUpdate = this.selectedPriceListId.id;
    this.selectedPaymentConditionIdUpdate = this.selectedPaymentConditionId.id;
    this.selectedDepartmentIdUpdate = this.selectedDepartmentId.id;
    this.selectedCityIdUpdate = this.selectedCityId.id;

    console.log(this.selectedTypeDocumentIdUpdate);
  }

  getCitiesOffice(val: any) {
    console.log(val);
    this.selectedCityOfficeId = 0;

    this.restService
      .getCities(Number(this.selectedDepartmentOfficeId.id))
      .then((data) => {
        const resp: any = data;
        console.log(data);
        swal.close();
        this.citiesOffice = resp.data;
        console.log(this.cities);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getCitiesOfficeUpdate() {
    // console.log(this.opcionSeleccionado);
    this.selectedCityOfficeIdUpdate = 0;
    console.log("oleole23" + this.selectedDepartmentOfficeIdUpdate);

    this.restService
      .getCities(this.selectedDepartmentOfficeIdUpdate)
      .then((data) => {
        const resp: any = data;
        console.log("Aca data de getCitiesOfficeUpdate ", data);
        swal.close();
        this.citiesOfficeUpdate = resp.data;
        console.log("Aca this cities", this.cities);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getAllCustomerTypes() {
    this.restService.getAllCustomerTypes().then(data => {
      const resp: any = data;
      this.customerTypes = resp.data;
      this.getCustomer(this.currentCustomerId);
    }).catch(error => {
      console.log(error);
    });
  }
  
  getAllCustomerOrigins() {
    this.restService.getAllCustomerOrigins().then(data => {
      const resp: any = data;
      this.customerOrigins = resp.data;

      console.log('/*/*/**//*/*/*/*', this.customerOrigins)
    }).catch(error => {
      console.log(error);
    });
  }
  
  getAllUserAdvisors() {
    this.restService.getUsersAdvisors()
      .subscribe(
        data => {
          const resp: any = data;
          this.userAdvisors = resp.data;
          console.log('userAdvisors: ', this.userAdvisors);
        },
        error => {
          console.log('getAllUserAdvisors error: ', error);
        }
      )
  }
  
  getAllCustomerAdvisors() {
    this.restService.getCustomerAdvisors(this.currentCustomerId)
      .subscribe(
        data => {
          const resp: any = data;
          if (resp.success) {
            console.log('customerAdvisors: ', resp.data);
            this.customerAdvisors = Array.isArray(resp.data) ? resp.data : [];
            this.updateAllRegionalAdvisors();
          }
        },
        error => {
          console.log('getAllCustomerAdvisors error: ', error);
        }
      )
  }
  
  asignCustomerAdvisor(user_id: number, regional_id: number, customer_advisor_id: number | null = null) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });

    const body: any = {
      customer_id: this.currentCustomerId,
      user_id: user_id,
      regional_id: regional_id
    };
    
    if (customer_advisor_id !== null) {
      body.customer_advisor_id = customer_advisor_id;
    }
    
    this.restService.asignCustomerAdvisor(body)
      .subscribe(
        data => {
          const resp: any = data;
          if (resp.success) {
            this.customerAdvisors = Array.isArray(resp.data) ? resp.data : [];
            this.getAllCustomerAdvisors();
            swal.close();
          } else {
            console.log('asignCustomerAdvisor error: ', resp);
            swal({
              title: "Se presentó un problema",
              text: "Volver a intentar mas tarde.",
              type: "error",
            });
          }
        },
        error => {
          console.log('asignCustomerAdvisor error: ', error);
          swal.close();
        }
      )
  }

  removeCustomerAdvisor(user_id: number, regional_id: number) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    console.log(`Removing advisor with user_id: ${user_id}, regional_id: ${regional_id} from customer_id: ${this.currentCustomerId}`);
    this.restService.removeCustomerAdvisor(this.currentCustomerId, regional_id, user_id)
      .subscribe(
        data => {
          const resp: any = data;
          if (resp.success) {
            this.customerAdvisors = Array.isArray(resp.data) ? resp.data : [];
            this.getAllCustomerAdvisors();
            swal.close();
          } else {
            console.log('removeCustomerAdvisor error: ', resp);
            swal({
              title: "Se presentó un problema",
              text: "Volver a intentar mas tarde.",
              type: "error",
            });
          }
        },
        error => {
          console.log('removeCustomerAdvisor error: ', error);
          swal.close();
        }
      )
  }

  updateAllRegionalAdvisors() {
    const advisors = Array.isArray(this.customerAdvisors) ? this.customerAdvisors : [];
    
    this.regionals.forEach(regional => {
      const foundAdvisors = advisors.filter(ca => ca.regional_id === regional.id);
      regional.advisors = foundAdvisors.map(ca => ({ userId: ca.user_id, customerAdvisorId: ca.id }));
    });
  }

  getAdvisorName(userId: number): string {
    const advisor = this.userAdvisors.find(a => a.id === userId);
    return advisor ? advisor.name : '';
  }

  getSelectedAdvisors(regionalId: number): regionalAdvisor[] {
    const regional = this.regionals.find(r => r.id === regionalId);
    return regional ? regional.advisors : [];
  }

  onAdvisorChange(regionalId: number, slotIndex: number, newAdvisorId: number) {
    const regional = this.regionals.find(r => r.id === regionalId);
    if (!regional) return;
    console.log('currentAdvisors: ', regional.advisors);
    console.log('currentSlotIndex: ', regional.advisors? [slotIndex] : []);
    const currentAdvisors = regional.advisors || [];
    const currentSlot = currentAdvisors[slotIndex] || { userId: 0, customerAdvisorId: null };
    const oldAdvisorId = currentSlot.userId || 0;
    const currentCustomerAdvisorId = currentSlot.customerAdvisorId || null;

    if (newAdvisorId !== 0 && newAdvisorId !== oldAdvisorId) {
      this.asignCustomerAdvisor(newAdvisorId, regionalId, currentCustomerAdvisorId);
    } else if (newAdvisorId === 0 && oldAdvisorId !== 0 && currentCustomerAdvisorId) {
      this.removeCustomerAdvisor(oldAdvisorId, regionalId);
    } else if (newAdvisorId === 0 && !currentCustomerAdvisorId) {
      currentSlot.userId = 0;
    }
  }

  getCustomer(id: number) {
    this.restService
      .getSpecificCustomer(id)
      .then((data: any) => {
        const resp: any = data.data;
        console.log("datosfffffffff");
        console.log(resp);
        this.customer = resp;
        console.log("importar datos");
        console.log(resp.telephone);
        this.myFormUpdate
          .get("typeDocumentIdUpdate")
          .setValue(resp.type_document_id);
        this.myFormUpdate.get("documentIdUpdate").setValue(resp.document_id);
        this.myFormUpdate
          .get("businessNameUpdate")
          .setValue(resp.business_name);
        this.myFormUpdate.get("telephoneUpdate").setValue(resp.telephone);
        this.myFormUpdate.get("emailUpdate").setValue(resp.email);
        this.myFormUpdate.get("addressUpdate").setValue(resp.address);
        this.myFormUpdate.get("priceMarginUpdate").setValue(resp.price_margin);
        //  this.myFormUpdate.get('priceListIdUpdate').setValue(resp.price_list_id);
        this.myFormUpdate
          .get("paymentConditionIdUpdate")
          .setValue(resp.payment_condition_id);
        this.myFormUpdate
          .get("departmentIdUpdate")
          .setValue(resp.department_id);

        const type = this.customerTypes.find(item => item.type === resp.customer_type);
        if (type) {
          this.myFormUpdate
            .get("customerType")
            .setValue(type.id);
        } else {
          this.myFormUpdate
            .get("customerType")
            .setValue(0);
        }

        this.myFormUpdate.get('customerOrigin').setValue(resp.customer_origin_id);

        if (!resp.comercial_email){
          this.myFormUpdate
            .get("comercialEmail")
            .setValue('');
        } else {
          this.myFormUpdate
            .get("comercialEmail")
            .setValue(resp.comercial_email);
        }

        if (resp.status == 0) {
          this.enabledCreatedOfficeUpdate = true;
        } else {
          this.enabledCreatedOfficeUpdate = false;
        }
        this.originalCustomerStatus = Number(resp.status);
        this.getCitiesOfficeUpdate();
        this.getCitiesUpdate();
      })
      .catch((error) => {
        this.messageError();
        console.log(error);
      });
  }

  getCitiesUpdate() {
    // console.log(this.opcionSeleccionado);
    this.selectedCityIdUpdate = 0;
    console.log("id:" + Number(this.selectedDepartmentIdUpdate));
    this.restService
      .getCities(Number(this.selectedDepartmentIdUpdate))
      .then((data) => {
        const resp: any = data;
        console.log("Aca data de getcities", data);
        swal.close();
        this.cities = resp.data;
        console.log(this.cities);
        this.myFormUpdate.get("cityIdUpdate").setValue(this.customer.city_id);
        console.log("se asigno");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  messageError() {
    swal({
      title: "Debe crear un cliente",
      text: "Luego de crear el cliente, puedes crear sedes",
      type: "error",
    });
  }

  updatedCustomer() {
    console.log(this.showButtonUpdated);
    console.log("Ole ole ole kakaakkaka");
    console.log(this.selectedTypeDocumentIdUpdate);
    console.log(this.selectedPaymentConditionIdUpdate);
    console.log(this.selectedDepartmentIdUpdate);
    console.log(this.selectedCityIdUpdate);
    // console.log(this.selectedPriceListIdUpdate);
    console.log(this.enabledCreatedOfficeUpdate);

    if (
      Number(this.selectedTypeDocumentIdUpdate) !== 0 &&
      Number(this.selectedPaymentConditionIdUpdate) !== 0 &&
      Number(this.selectedDepartmentIdUpdate) !== 0 &&
      Number(this.selectedCityIdUpdate) !== 0 &&
      Number(this.myFormUpdate.get('customerType').value) !== 0 &&
      Number(this.myFormUpdate.get('customerOrigin').value) !== 0
    ) {
      this.submittedUpdated = true;
      if (!this.myFormUpdate.invalid) {
        let statusTemp = 1;
        console.log(this.switchUpdate);
        if (this.enabledCreatedOfficeUpdate) {
          statusTemp = 0;
        }
        console.log("kakakaka");

        const statusModified = this.originalCustomerStatus !== null && statusTemp !== this.originalCustomerStatus;

        if (statusModified) {
          this.askStatusChangeReason(statusTemp);
        } else {
          this.executeUpdateCustomer(statusTemp, '');
        }
      }
    } else {
      swal({
        title: "Debe seleccionar todos los campos obligatorios",
        text: "Debe seleccionar todos los campos obligatorios",
        type: "error",
      });
    }
  }

  askStatusChangeReason(statusTemp: number) {
    swal({
      title: "Razón del cambio de estado",
      text: "El estado del cliente fue modificado. Ingrese la razón del cambio.",
      input: "textarea",
      inputPlaceholder: "Ingrese la razón...",
      inputAttributes: {
        maxlength: "255",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "La razón es obligatoria";
        }
        if (value.length > 255) {
          return "La razón no puede superar los 255 caracteres";
        }
      },
    }).then((result) => {
      if (result.value) {
        this.executeUpdateCustomer(statusTemp, result.value.trim());
      }
    });
  }

  executeUpdateCustomer(statusTemp: number, reason: string) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.restService
      .updateCustomer(
        Number(this.customer.id),
        this.myFormUpdate.get("businessNameUpdate").value.toUpperCase(),
        this.selectedTypeDocumentIdUpdate,
        this.myFormUpdate.get("documentIdUpdate").value,
        this.myFormUpdate.get("telephoneUpdate").value,
        this.myFormUpdate.get("addressUpdate").value,
        statusTemp,
        this.myFormUpdate.get("priceMarginUpdate").value,
        this.selectedPaymentConditionIdUpdate,
        this.selectedCityIdUpdate,
        this.selectedDepartmentIdUpdate,
        this.myFormUpdate.get('customerType').value,
        this.myFormUpdate.get('comercialEmail').value,
        this.myFormUpdate.get("emailUpdate").value,
        this.myFormUpdate.get("customerOrigin").value,
        this.userId,
        reason
      )
      .then((data) => {
        const resp: any = data;
        console.log(JSON.stringify(resp));
        if (resp.error && resp.error.success === false) {
          swal({
            title: "Este tercero ya esta registrado",
            text: "Este tercero no se puede registrar",
            type: "error",
          });
        } else {
          this.getMasters(1);
          // this.getOffices();

          console.log("Cambio");
          /*swal({
           title: 'tercero agregada',
           type: 'success'
          });*/
          //   this.router.navigateByUrl('master/registerBrand');

          // document.getElementById( 'createBrandHide').click();
          // this.loadingData();
          swal({
            title: "Tercero agregado",
            type: "success",
          });
          this.originalCustomerStatus = statusTemp;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /*onChangeCreated(check: any) {
    this.switchUpdate = check;
    this.enabledCreated = check;
    this.enabledUpdated = this.enabledCreated ;
      }



  onChangeCreated(check: any) {
    this.switchUpdate = check;
    this.enabledCreated = check;
    this.enabledUpdated = this.enabledCreated ;
      }*/

  onChangeCreated(check: any) {
    // this.switchUpdate = check;
    this.enabledCreated = check;
    // this.enabledUpdated = this.enabledCreated ;
  }

  onChangeCreatedOfficeUpdate(check: any) {
    console.log(check);
    this.enabledCreatedOfficeUpdate = check;
  }

  onChangeCreatedOffice(check: any) {
    this.enabledCreatedOffice = check;
  }

  onChangeUpdated(check: any) {
    //  this.switchUpdate = check;
    this.enabledUpdated = check;
  }
  getMasters(indice: number) {
    // console.log(this.opcionSeleccionado);
    this.restService
      .getMastersThird()
      .then((data) => {
        const resp: any = data;
        this.dataMasters = data;
        this.paymentConditions = this.dataMasters.payment_condition;
        this.typeDocuments = this.dataMasters.documents;
        this.departments = this.dataMasters.department;
        console.warn("Departamentos",this.departments)
        //  this.priceList = this.dataMasters.price_list;
        console.log("master");
        console.log(data);
        swal.close();

        /* if (indice === 1) {

         console.log('oleole2');
         console.log(this.selectedTypeDocumentId);
         console.log(this.selectedTypeDocumentId.id);
         this.selectedTypeDocumentIdUpdate = '3'; // String(this.selectedTypeDocumentId.id);
         this.selectedPriceListIdUpdate = this.selectedPriceListId;
         this.selectedPaymentConditionIdUpdate = this.selectedPaymentConditionId;
         this.selectedDepartmentIdUpdate = this.selectedDepartmentId;
         this.selectedCityIdUpdate = this.selectedCityIdUpdate;
       }*/
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getOffices(idCustomer: number) {
    // console.log(this.opcionSeleccionado);
    this.restService
      .getCustomerOffice(idCustomer)
      .then((data) => {
        console.log("que mas ps");
        const resp: any = data;
        console.log(resp);
        this.dataOffices = resp.data_branchoffices;

        console.log("Importante ver la info");
        console.log(this.dataOffices);
        // this.selectedTypeDocumentIdUpdate = resp.customer.type_document_id;
        // this.selectedPriceListIdUpdate = resp.customer.price_list_id;
        // this.selectedPaymentConditionIdUpdate = resp.customer.payment_condition_id;
        // this.selectedDepartmentIdUpdate = resp.customer.department_id;
        // this.selectedCityIdUpdate = resp.data_branchoffices.city_id;
        console.log(
          "antes de consulta " + resp.data_branchoffices[0].department_id
        );
        //   this.dataOffices = this.dataOffices.data;
        console.log("master");
        swal.close();
        // this.cities = resp.data;
        console.log(this.dataOffices);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  deleteBrand(brand: any) {
    swal({
      title: "Estás seguro de eliminar este elemento?",
      // text: 'Once deleted, you will not be able to recover this imaginary file!',
      type: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Si",
    }).then((willDelete) => {
      if (willDelete.value) {
        this.elementDelete = brand;
        console.log(brand);
        console.log(this.elementDelete);
        swal.showLoading();
        this.restService
          .deleteOffice(Number(this.elementDelete.id))
          .then((data) => {
            swal.showLoading();
            const resp: any = data;
            console.log(resp);
            this.getOffices(this.currentCustomerId);
            if (resp.success === false) {
              swal({
                title: "Esta marca presenta problemas",
                text: "Esta marca no se puede eliminar",
                type: "error",
              });
            } else {
              // this.router.navigateByUrl('master/registerBrand');
              swal({
                title: "Marca eliminada",
                type: "success",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // swal('Fail');
      }
      console.log(willDelete);
    });
  }

  onChange(d: any) {
    console.log("jajaja");
    console.log(d);
  }

  preview(files) {
    if (files.length === 0) {
      return console.log("jaja");
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }

  // updatedOffice() {
  //   console.log("datos a actualizar");
  //   console.log(this.currentOffice);

  //   try {
  //     if ( Number(this.selectedDepartmentOfficeIdUpdate) !== 0 && Number(this.selectedCityOfficeIdUpdate) !== 0) {
  //       this.submittedOffice = true;
  //       console.log(this.myFormCreateOffice.errors);
  //      if ( !this.myFormUpdateOffice.invalid) {
  //       swal({
  //         title: 'Validando información ...',
  //         allowOutsideClick: false
  //       });
  //       swal.showLoading();
  //       let statusTemp = 0;
  //       console.log( this.switchUpdate);
  //       if ( this.enabledCreatedOfficeUpdate === false) {
  //         statusTemp = 1;
  //       }
  //       this.restService.updateOffice(this.currentOffice.id,this.currentCustomerId, this.myFormUpdateOffice.get('nameOfficeUpdate').value.toUpperCase())
  //       .then(data => {
  //         const resp: any = data;
  //         console.log(resp);
  //         if (resp.success === false) {
  //           swal({
  //             title: 'Esta sede ya esta registrada',
  //             text: 'Esta sede no se puede registrar',
  //             type: 'error'
  //            });
  //         } else {
  //      this.myFormCreateOffice.reset();
  //      document.getElementById( 'createBrandHide').click();
  //      this.getOffices(this.currentCustomerId);
  //      document.getElementById('updateBrandHide').click();
  //      swal({
  //       title: 'Sede Actualizada',
  //       type: 'success'
  //      });
  //       }
  //       }).catch(error => {
  //         console.log(error);
  //       });
  //       }
  //     } else {
  //       console.log('llegod');
  //       swal({
  //         title: 'Debe seleccionar todos los campos obligatorios',
  //         text: 'Debe seleccionar todos los campos obligatorios',
  //         type: 'error'
  //        });
  //     }
  //   } catch (error) {
  //   console.log(error);
  //   }
  // }

  // sendOffice() {
  //   try {
  //   console.log('Ole ole ole');
  //   console.log(this.selectedDepartmentOfficeId);
  //   console.log(this.selectedCityOfficeId);
  //   if ( Number(this.selectedDepartmentOfficeId) !== 0 && Number(this.selectedCityOfficeId) !== 0) {
  //     this.submittedOffice = true;
  //     console.log('---------------');

  //    if ( !this.myFormCreateOffice.invalid) {
  //     swal({
  //       title: 'Validando información ...',
  //       allowOutsideClick: false
  //     });
  //     swal.showLoading();

  //     let statusTemp = 0;
  //     console.log( this.enabledCreatedOffice);
  //     if ( this.enabledCreatedOffice === false) {
  //       statusTemp = 1;
  //     }
  //     this.restService.createOffice(this.currentCustomerId, this.myFormCreateOffice.get('nameOffice').value.toUpperCase())
  //     .then(data => {
  //       const resp: any = data;
  //       console.log(resp);
  //       if (resp.success === false) {
  //         swal({
  //           title: 'Esta sede ya esta registrada',
  //           text: 'Esta sede no se puede registrar',
  //           type: 'error'
  //          });
  //       } else {
  //         this.myFormCreateOffice.reset();
  //         document.getElementById( 'createBrandHide').click();
  //         this.getOffices(this.currentCustomerId);
  //         swal({
  //           title: 'Sede agregada',
  //           type: 'success'
  //         });
  //       }
  //     }).catch(error => {
  //       console.log(error);
  //     });
  //     }
  //   } else {
  //     console.log('llegod');
  //     swal({
  //       title: 'Debe seleccionar todos los campos obligatorios',
  //       text: 'Debe seleccionar todos los campos obligatorios',
  //       type: 'error'
  //      });
  //   }
  // } catch (error) {
  // console.log(error);
  // }
  // }

  goAdminCustomer() {
    this.router.navigateByUrl("master/customers");
  }

  get checkForm() {
    return this.myForm.controls;
  }
  get checkFormUpdate() {
    return this.myFormUpdate.controls;
  }
  get checkFormOffice() {
    return this.myFormCreateOffice.controls;
  }
  get checkFormOfficeUpdate() {
    return this.myFormUpdateOffice.controls;
  }

  createDeliveryAddrees(
    addressForm: string,
    regional: any,
    observation: string,
    selecteDepartmentId: string,
    selectedcityId: string,
    citi: any,
    department: any,
  ) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //console.log("Dirección ingresada:", addressForm);
    //console.log("Sucursal seleccionada:", regional);
    //console.log("Selecy:", this.selectedBusinessIdForm);
    //console.log("Adresobservation:", this.addressObservation);
    console.log("selecteDepartmentId:", this.selecteDepartmentId);
    console.log("selectedcityId:", this.selectedcityId);
    console.log("citi:", citi);
    console.log("department:", department);
    const postData = {
      address: addressForm,
      customer_id: regional.customer_id,
      regional_id: regional.id,
      regional_description: regional.description,
      observation: observation,
      idel: 0,
      department_id: this.selecteDepartmentId.id,
      department_name: this.selecteDepartmentId.name,
      citi_name: this.selectedcityId.name,
      citi_id: this.selectedcityId.id,
     
    };
    console.log("Acaaa data para post", postData);
     this.orderservice.createDeliveryAddrees(postData).then((data) => {
       if (data && typeof data === "object" && "success" in data) {
         console.log("Se ha creado el post", data);
         document.getElementById("createItemHide").click();
         this.ngOnInit();
         swal.close();

         swal({
           title: "Direccion de entrega creada correctamente",
           type: "success",
         });
       } else {
         console.log("Error al crear POSTLOGIST:", data);
         // Manejo Adicional de errores
       }
     });
  }

  getDeliverysAdrres() {
    const customer_id = this.currentCustomerId;

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getDeliverysAdrres(customer_id)
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.deliveryAddress = resp.data;
        console.warn(
          "Data recibida de direcciones de entrega:",
          this.deliveryAddress,
          "Del cliente",
          customer_id
        );

        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }


  deleteAddress(address) {
    
    console.log("Aca edito la adrress", address);
    

    // Mostrar alerta de confirmación
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar esta dirección?");
    
    // Si el usuario confirma la eliminación
    if (confirmDelete) {
        const id = address.id;
        const postData = {
            idel: 1,
        };

        console.log("Acaa DATA para pasar a edicion", postData);
        console.log("Acaa ID para pasar a edicion", id);

        // Llamada al servicio para eliminar la dirección
        this.orderservice.deleteAddressDelivery(id, postData).then((data) => {
            if (data && typeof data === "object" && "success" in data) {
                this.isVisibleEdit = false;
                console.log("Se ha Eliminado", data);

                // Mostrar mensaje de éxito
                swal({
                    title: "Se ha Eliminado la dirección",
                    type: "success",
                });

                // Refrescar la vista
                this.ngOnInit();
            } else {
                console.log("Error al eliminar dirección:", data);
                // Manejo Adicional de errores
            }
        });
    } else {
        // Si el usuario cancela la operación, no hacer nada
        console.log("Eliminación cancelada");
    }
  }

  showModalEdit(address) {
    this.isVisibleEdit = true;
    console.log("Mostrando si es visible");
    this.editaddress = address.address;
    this.editObservation = address.observation;
    this.idEditAddres = address.id;

    console.log(
      "Acaaa datos para Modal",
      this.editaddress,
      this.editObservation,
      address
    );
  }

  closeModalEdit() {
    this.isVisibleEdit = false;
  }

  editAddress() {
    console.log(
      "Acaaa mandando datos editados",
      this.editaddress,
      this.editObservation
    );
    const id = this.idEditAddres;
    const postData = {
      address: this.editaddress,
      observation: this.editObservation,
    };
    console.log("Acaa DATA para pasar a edicion", postData);
    console.log("Acaa ID para pasar a edicion", id);

    this.orderservice.updateAddressDelivery(id, postData).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        this.isVisibleEdit = false;
        console.log("Se ha creado la actualizacion de Direccion", data);
        swal({
          title: "Se ha actualizado la dirección",
          type: "success",
        });

        this.ngOnInit();
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo Adicional de errores
      }
    });
  }

  onDepartmentChange(event: Event): void {
    const selectedDepartment = this.departments.find(dept => dept.id === this.selecteDepartmentId.id);

    if (selectedDepartment) {
      console.log('Departamento seleccionado:', selectedDepartment);
      const id=selectedDepartment.id
      console.log("Acaaa id para pasar al servicio de citis",id)
      swal({
        title: "Obteniendo información ...",
        allowOutsideClick: false,
      });
      swal.showLoading();
      this.orderservice
        .getcities(id)
        .then((data) => {
          const resp: any = data;
          console.log(data);
  
          this.cities = resp.data;
          console.warn(
            "Data recibida de ciudades",
            this.cities
          );
  
          swal.close();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('No se ha seleccionado un departamento válido.');
    }
  }

  toggleOriginForm(originId: number = 0) {
    if (this.modalFormOrigin.visible) {
      this.modalFormOrigin.hide();
      this.newOrigin = '';
      this.originIdToEdit = 0;
      return;
    }
    
    this.originIdToEdit = originId;
    if (originId) {
      const origin = this.customerOrigins.find(o => o.id === originId);
      if (origin) {
        this.newOrigin = origin.origin;
      }
    }
    this.modalFormOrigin.show();
  }
  
  createOrigin() {
      swal({
        title: 'Validando información ...',
        allowOutsideClick: false
      });
      swal.showLoading();

      if (!this.newOrigin) {
        swal({
          title: 'Por favor ingrese el nuevo origen',
          text: 'Debe ingresar una descripcion valida para el origen',
          type: 'error'
        });
        return;
      }

      const newOriginBody = { origin: this.newOrigin };

      this.restService.createCustomerOrigin(newOriginBody)
        .subscribe(
          data => {
            this.getAllCustomerOrigins();
            swal({
              title: 'Origen agregado',
              type: 'success'
            });
            this.toggleOriginForm();
          },
          error => {
            console.log(error);
            swal({
              title: 'Error al agregar el origen',
              text: 'Ocurrió un error al intentar agregar el nuevo origen',
              type: 'error'
            });
          }
        );
  }
  
  updateOrigin() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    if (!this.newOrigin) {
      swal({
        title: 'Por favor ingrese el origen',
        text: 'Debe ingresar una descripcion valida para el origen',
        type: 'error'
      });
      return;
    }

    const originBody = { origin: this.newOrigin };

    this.restService.updateCustomerOrigin(this.originIdToEdit, originBody)
      .subscribe(
        data => {
          this.getAllCustomerOrigins();
          swal({
            title: 'Origen modificado',
            type: 'success'
          });
          this.toggleOriginForm();
        },
        error => {
          console.log(error);
          swal({
            title: 'Error al modificar el origen',
            text: 'Ocurrió un error al intentar modificar el origen',
            type: 'error'
          });
        }
      );
  }
 

 

  ////////

  getCustomerContacts() {
    this.restService
      .getCustomerContacts(this.currentCustomerId)
      .then((data: any) => {
        const resp: any = data;
        console.log("Customer contacts:", resp);
        if (resp.success) {
          this.customerContacts = resp.data.sort((a: any, b: any) => {
            const nameA = (a.regional && a.regional.description) ? a.regional.description : 'Sin sucursal';
            const nameB = (b.regional && b.regional.description) ? b.regional.description : 'Sin sucursal';
            return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showContactModal(contact?: ICustomerContact) {
    if (contact) {
      this.isEditingContact = true;
      this.editContactId = contact.id;
      this.contactForm = {
        name: contact.name || '',
        email: contact.email || '',
        telephone: contact.telephone || '',
        regional_id: contact.regional_id || 0
      };
    } else {
      this.isEditingContact = false;
      this.editContactId = 0;
      this.contactForm = { name: '', email: '', telephone: '', regional_id: 0 };
    }
    this.isContactModalVisible = true;
  }

  closeContactModal() {
    this.isContactModalVisible = false;
    this.editContactId = 0;
    this.isEditingContact = false;
    this.contactForm = { name: '', email: '', telephone: '', regional_id: 0 };
  }

  saveContact() {
    if (!this.contactForm.name) {
      swal({
        title: "Campos requeridos",
        text: "El nombre del contacto es obligatorio",
        type: "error",
        backdrop: false,
        toast: true,
        position: 'top',
        showConfirmButton: true
      });
      return;
    }

    swal({
      title: "Guardando...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    if (this.isEditingContact) {
      this.restService
        .updateCustomerContact(this.editContactId, {
          name: this.contactForm.name,
          email: this.contactForm.email,
          telephone: this.contactForm.telephone,
          regional_id: this.contactForm.regional_id || null
        })
        .then((data: any) => {
          swal.close();
          if (data.success) {
            swal({
              title: "Contacto actualizado",
              type: "success",
            });
            this.closeContactModal();
            this.getCustomerContacts();
          } else {
            swal({
              title: "Error",
              text: data.message || "No se pudo actualizar el contacto",
              type: "error",
            });
          }
        })
        .catch((error) => {
          swal.close();
          console.log(error);
        });
    } else {
      const contactData = {
        customer_id: this.currentCustomerId,
        regional_id: this.contactForm.regional_id || null,
        name: this.contactForm.name,
        email: this.contactForm.email,
        telephone: this.contactForm.telephone
      };
      this.restService
        .createCustomerContact(contactData)
        .then((data: any) => {
          swal.close();
          if (data.success) {
            swal({
              title: "Contacto creado",
              type: "success",
            });
            this.closeContactModal();
            this.getCustomerContacts();
          } else {
            swal({
              title: "Error",
              text: data.message || "No se pudo crear el contacto",
              type: "error",
            });
          }
        })
        .catch((error) => {
          swal.close();
          console.log(error);
        });
    }
  }

  deleteContact(contact: ICustomerContact) {
    swal({
      title: "¿Estás seguro de eliminar este contacto?",
      type: "warning",
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Si",
    }).then((willDelete) => {
      if (willDelete.value) {
        swal.showLoading();
        this.restService
          .deleteCustomerContact(contact.id)
          .then((data: any) => {
            swal.close();
            if (data.success) {
              swal({
                title: "Contacto eliminado",
                type: "success",
              });
              this.getCustomerContacts();
            } else {
              swal({
                title: "Error",
                text: data.message || "No se pudo eliminar el contacto",
                type: "error",
              });
            }
          })
          .catch((error) => {
            swal.close();
            console.log(error);
          });
      }
    });
  }

  getRegionalDescription(regionalId: number): string {
    const regional = this.rowsRegionals.find(r => r.regional_id === regionalId);
    return regional ? regional.description : 'Sin sucursal';
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-update-customer/master-update-customer.component.ts